import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NgZorroModule } from '../../../../shared/modules/ng-zorro/ng-zorro.module';
import { TimesheetService } from '../../../../services/timesheet.service';
import { UserService } from '../../../../services/user.service';
import { CommonModule } from '@angular/common';



@Component({
  selector: 'ppl-auth-utilization',
  standalone: true,
  imports: [NgZorroModule, CommonModule],
  templateUrl: './auth-utilization.component.html',
  styleUrl: './auth-utilization.component.css'
})
export class AuthUtilizationComponent implements OnInit, OnChanges {
  programName!: string;
  columnsToBeHidden: string[] = [];
  sharedDataKey!: string;
  actionsToBeHidden: string[] = [];
  lazyLoad = true;
  isPageRestrictionLoaded = false;
  @Input() authData:any;
  authUtilizationData: any;

  constructor(private timesheetService: TimesheetService, private userService: UserService){
  }

  ngOnInit() {
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
    this.isPageRestrictionLoaded = true;
  }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes['authData'] && changes['authData'].currentValue) {
        this.getUtilizationData();
      }
    }
  
    getUtilizationData(){
      this.timesheetService.getAuthUtilization(this.programName, this.authData?.participantId, this.authData?.authorizationId, ).subscribe((data:any)=>{
        this.authUtilizationData = data.responsedata;

        if (this.authUtilizationData?.usedUnits && this.authUtilizationData?.authUnit) {
          this.authUtilizationData.remainingUnits = this.authUtilizationData.authUnit - this.authUtilizationData.usedUnits;
        } else {
          this.authUtilizationData.remainingUnits = this.authUtilizationData?.authUnit ?? 0;
        }
      })
    }

}
